function _typeof(o) { "@babel/helpers - typeof"; return _typeof = "function" == typeof Symbol && "symbol" == typeof Symbol.iterator ? function (o) { return typeof o; } : function (o) { return o && "function" == typeof Symbol && o.constructor === Symbol && o !== Symbol.prototype ? "symbol" : typeof o; }, _typeof(o); }
function _slicedToArray(r, e) { return _arrayWithHoles(r) || _iterableToArrayLimit(r, e) || _unsupportedIterableToArray(r, e) || _nonIterableRest(); }
function _nonIterableRest() { throw new TypeError("Invalid attempt to destructure non-iterable instance.\nIn order to be iterable, non-array objects must have a [Symbol.iterator]() method."); }
function _unsupportedIterableToArray(r, a) { if (r) { if ("string" == typeof r) return _arrayLikeToArray(r, a); var t = {}.toString.call(r).slice(8, -1); return "Object" === t && r.constructor && (t = r.constructor.name), "Map" === t || "Set" === t ? Array.from(r) : "Arguments" === t || /^(?:Ui|I)nt(?:8|16|32)(?:Clamped)?Array$/.test(t) ? _arrayLikeToArray(r, a) : void 0; } }
function _arrayLikeToArray(r, a) { (null == a || a > r.length) && (a = r.length); for (var e = 0, n = Array(a); e < a; e++) n[e] = r[e]; return n; }
function _iterableToArrayLimit(r, l) { var t = null == r ? null : "undefined" != typeof Symbol && r[Symbol.iterator] || r["@@iterator"]; if (null != t) { var e, n, i, u, a = [], f = !0, o = !1; try { if (i = (t = t.call(r)).next, 0 === l) { if (Object(t) !== t) return; f = !1; } else for (; !(f = (e = i.call(t)).done) && (a.push(e.value), a.length !== l); f = !0); } catch (r) { o = !0, n = r; } finally { try { if (!f && null != t.return && (u = t.return(), Object(u) !== u)) return; } finally { if (o) throw n; } } return a; } }
function _arrayWithHoles(r) { if (Array.isArray(r)) return r; }
function _regenerator() { /*! regenerator-runtime -- Copyright (c) 2014-present, Facebook, Inc. -- license (MIT): https://github.com/babel/babel/blob/main/packages/babel-helpers/LICENSE */ var e, t, r = "function" == typeof Symbol ? Symbol : {}, n = r.iterator || "@@iterator", o = r.toStringTag || "@@toStringTag"; function i(r, n, o, i) { var c = n && n.prototype instanceof Generator ? n : Generator, u = Object.create(c.prototype); return _regeneratorDefine2(u, "_invoke", function (r, n, o) { var i, c, u, f = 0, p = o || [], y = !1, G = { p: 0, n: 0, v: e, a: d, f: d.bind(e, 4), d: function d(t, r) { return i = t, c = 0, u = e, G.n = r, a; } }; function d(r, n) { for (c = r, u = n, t = 0; !y && f && !o && t < p.length; t++) { var o, i = p[t], d = G.p, l = i[2]; r > 3 ? (o = l === n) && (u = i[(c = i[4]) ? 5 : (c = 3, 3)], i[4] = i[5] = e) : i[0] <= d && ((o = r < 2 && d < i[1]) ? (c = 0, G.v = n, G.n = i[1]) : d < l && (o = r < 3 || i[0] > n || n > l) && (i[4] = r, i[5] = n, G.n = l, c = 0)); } if (o || r > 1) return a; throw y = !0, n; } return function (o, p, l) { if (f > 1) throw TypeError("Generator is already running"); for (y && 1 === p && d(p, l), c = p, u = l; (t = c < 2 ? e : u) || !y;) { i || (c ? c < 3 ? (c > 1 && (G.n = -1), d(c, u)) : G.n = u : G.v = u); try { if (f = 2, i) { if (c || (o = "next"), t = i[o]) { if (!(t = t.call(i, u))) throw TypeError("iterator result is not an object"); if (!t.done) return t; u = t.value, c < 2 && (c = 0); } else 1 === c && (t = i.return) && t.call(i), c < 2 && (u = TypeError("The iterator does not provide a '" + o + "' method"), c = 1); i = e; } else if ((t = (y = G.n < 0) ? u : r.call(n, G)) !== a) break; } catch (t) { i = e, c = 1, u = t; } finally { f = 1; } } return { value: t, done: y }; }; }(r, o, i), !0), u; } var a = {}; function Generator() {} function GeneratorFunction() {} function GeneratorFunctionPrototype() {} t = Object.getPrototypeOf; var c = [][n] ? t(t([][n]())) : (_regeneratorDefine2(t = {}, n, function () { return this; }), t), u = GeneratorFunctionPrototype.prototype = Generator.prototype = Object.create(c); function f(e) { return Object.setPrototypeOf ? Object.setPrototypeOf(e, GeneratorFunctionPrototype) : (e.__proto__ = GeneratorFunctionPrototype, _regeneratorDefine2(e, o, "GeneratorFunction")), e.prototype = Object.create(u), e; } return GeneratorFunction.prototype = GeneratorFunctionPrototype, _regeneratorDefine2(u, "constructor", GeneratorFunctionPrototype), _regeneratorDefine2(GeneratorFunctionPrototype, "constructor", GeneratorFunction), GeneratorFunction.displayName = "GeneratorFunction", _regeneratorDefine2(GeneratorFunctionPrototype, o, "GeneratorFunction"), _regeneratorDefine2(u), _regeneratorDefine2(u, o, "Generator"), _regeneratorDefine2(u, n, function () { return this; }), _regeneratorDefine2(u, "toString", function () { return "[object Generator]"; }), (_regenerator = function _regenerator() { return { w: i, m: f }; })(); }
function _regeneratorDefine2(e, r, n, t) { var i = Object.defineProperty; try { i({}, "", {}); } catch (e) { i = 0; } _regeneratorDefine2 = function _regeneratorDefine(e, r, n, t) { function o(r, n) { _regeneratorDefine2(e, r, function (e) { return this._invoke(r, n, e); }); } r ? i ? i(e, r, { value: n, enumerable: !t, configurable: !t, writable: !t }) : e[r] = n : (o("next", 0), o("throw", 1), o("return", 2)); }, _regeneratorDefine2(e, r, n, t); }
function ownKeys(e, r) { var t = Object.keys(e); if (Object.getOwnPropertySymbols) { var o = Object.getOwnPropertySymbols(e); r && (o = o.filter(function (r) { return Object.getOwnPropertyDescriptor(e, r).enumerable; })), t.push.apply(t, o); } return t; }
function _objectSpread(e) { for (var r = 1; r < arguments.length; r++) { var t = null != arguments[r] ? arguments[r] : {}; r % 2 ? ownKeys(Object(t), !0).forEach(function (r) { _defineProperty(e, r, t[r]); }) : Object.getOwnPropertyDescriptors ? Object.defineProperties(e, Object.getOwnPropertyDescriptors(t)) : ownKeys(Object(t)).forEach(function (r) { Object.defineProperty(e, r, Object.getOwnPropertyDescriptor(t, r)); }); } return e; }
function _defineProperty(e, r, t) { return (r = _toPropertyKey(r)) in e ? Object.defineProperty(e, r, { value: t, enumerable: !0, configurable: !0, writable: !0 }) : e[r] = t, e; }
function _toPropertyKey(t) { var i = _toPrimitive(t, "string"); return "symbol" == _typeof(i) ? i : i + ""; }
function _toPrimitive(t, r) { if ("object" != _typeof(t) || !t) return t; var e = t[Symbol.toPrimitive]; if (void 0 !== e) { var i = e.call(t, r || "default"); if ("object" != _typeof(i)) return i; throw new TypeError("@@toPrimitive must return a primitive value."); } return ("string" === r ? String : Number)(t); }
function asyncGeneratorStep(n, t, e, r, o, a, c) { try { var i = n[a](c), u = i.value; } catch (n) { return void e(n); } i.done ? t(u) : Promise.resolve(u).then(r, o); }
function _asyncToGenerator(n) { return function () { var t = this, e = arguments; return new Promise(function (r, o) { var a = n.apply(t, e); function _next(n) { asyncGeneratorStep(a, r, o, _next, _throw, "next", n); } function _throw(n) { asyncGeneratorStep(a, r, o, _next, _throw, "throw", n); } _next(void 0); }); }; }
// +----------------------------------------------------------------------
// | CRMEB [ CRMEB赋能开发者，助力企业发展 ]
// +----------------------------------------------------------------------
// | Copyright (c) 2016~2026 https://www.crmeb.com All rights reserved.
// +----------------------------------------------------------------------
// | Licensed CRMEB并不是自由软件，未经许可不能去掉CRMEB相关版权
// +----------------------------------------------------------------------
// | Author: CRMEB Team <admin@crmeb.com>
// +----------------------------------------------------------------------

import router from './router';
import store from './store';
import { Message } from 'element-ui';
import NProgress from 'nprogress'; // progress bar
import 'nprogress/nprogress.css'; // progress bar style
import { getToken, setToken } from '@/utils/auth'; // get token from cookie
import getPageTitle from '@/utils/get-page-title';
import Cookies from 'js-cookie';
import { getLoginInfo } from '@/libs/public';
import { getBaseInfoApi, merchantConfigInfoApi } from '@/api/merchant';
NProgress.configure({
  showSpinner: false
}); // NProgress Configuration

var whiteList = ['/login', '/auth-redirect']; // no redirect whitelist
var storeInfoPath = '/operation/modifyStoreInfo';
var storeInfoGuideQuery = {
  tab: 'storeInfo',
  guide: 'openStore'
};
var storeInfoGuideCheckedToken = '';
function hasPermission(permission) {
  var permissions = store.getters.permissions || [];
  return permissions.includes('*:*:*') || permissions.includes(permission);
}
function isBlank(value) {
  return value === undefined || value === null || String(value).trim() === '';
}
function isOpenStoreConfigIncomplete() {
  var config = arguments.length > 0 && arguments[0] !== undefined ? arguments[0] : {};
  var imageMissing = [config.avatar, config.backImage, config.streetBackImage].some(isBlank);
  var serviceMissing = isBlank(config.serviceLink) && isBlank(config.servicePhone);
  return imageMissing || serviceMissing;
}
function blockDisabledPetRoute(to, next) {
  if (to.path.startsWith('/pet') && Cookies.get('petFeatureEnabled') !== 'true') {
    Message.warning('商户未开通宠物功能');
    next('/404');
    NProgress.done();
    return true;
  }
  return false;
}
function getStoreInfoGuideRoute(_x) {
  return _getStoreInfoGuideRoute.apply(this, arguments);
}
function _getStoreInfoGuideRoute() {
  _getStoreInfoGuideRoute = _asyncToGenerator(/*#__PURE__*/_regenerator().m(function _callee2(to) {
    var token, _yield$Promise$all, _yield$Promise$all2, baseInfo, configInfo, shouldGuide, alreadyOnGuide, _t2;
    return _regenerator().w(function (_context2) {
      while (1) switch (_context2.p = _context2.n) {
        case 0:
          token = getToken();
          if (!(!token || storeInfoGuideCheckedToken === token)) {
            _context2.n = 1;
            break;
          }
          return _context2.a(2, null);
        case 1:
          storeInfoGuideCheckedToken = token;
          if (!(!hasPermission('merchant:base:info') || !hasPermission('merchant:config:info') || !hasPermission('merchant:config:info:edit'))) {
            _context2.n = 2;
            break;
          }
          return _context2.a(2, null);
        case 2:
          _context2.p = 2;
          _context2.n = 3;
          return Promise.all([getBaseInfoApi(), merchantConfigInfoApi()]);
        case 3:
          _yield$Promise$all = _context2.v;
          _yield$Promise$all2 = _slicedToArray(_yield$Promise$all, 2);
          baseInfo = _yield$Promise$all2[0];
          configInfo = _yield$Promise$all2[1];
          shouldGuide = baseInfo && baseInfo.isSwitch === false && isOpenStoreConfigIncomplete(configInfo);
          alreadyOnGuide = to.path === storeInfoPath && to.query.tab === storeInfoGuideQuery.tab;
          if (!(shouldGuide && !alreadyOnGuide)) {
            _context2.n = 4;
            break;
          }
          Message.warning('请先完善店铺资料，再开启店铺');
          return _context2.a(2, {
            path: storeInfoPath,
            query: storeInfoGuideQuery,
            replace: true
          });
        case 4:
          _context2.n = 6;
          break;
        case 5:
          _context2.p = 5;
          _t2 = _context2.v;
          return _context2.a(2, null);
        case 6:
          return _context2.a(2, null);
      }
    }, _callee2, null, [[2, 5]]);
  }));
  return _getStoreInfoGuideRoute.apply(this, arguments);
}
router.beforeEach(/*#__PURE__*/function () {
  var _ref = _asyncToGenerator(/*#__PURE__*/_regenerator().m(function _callee(to, from, next) {
    var _to$query, token, account, isSms, leftSquareLogo, leftTopLogo, realName, guideRoute, hasToken, hasRoles, _guideRoute, _guideRoute2, _t;
    return _regenerator().w(function (_context) {
      while (1) switch (_context.p = _context.n) {
        case 0:
          // start progress bar
          NProgress.start();
          // set page title
          document.title = getPageTitle(to.meta.title);
          if (!to.query.token) {
            _context.n = 6;
            break;
          }
          _to$query = to.query, token = _to$query.token, account = _to$query.account, isSms = _to$query.isSms, leftSquareLogo = _to$query.leftSquareLogo, leftTopLogo = _to$query.leftTopLogo, realName = _to$query.realName;
          getLoginInfo(to.query);
          _context.n = 1;
          return store.dispatch('user/getMenus');
        case 1:
          _context.n = 2;
          return store.dispatch('user/getInfo');
        case 2:
          _context.n = 3;
          return store.dispatch('settings/getFrontDomain');
        case 3:
          if (!blockDisabledPetRoute(to, next)) {
            _context.n = 4;
            break;
          }
          return _context.a(2);
        case 4:
          _context.n = 5;
          return getStoreInfoGuideRoute(to);
        case 5:
          guideRoute = _context.v;
          guideRoute ? next(guideRoute) : next();
          NProgress.done();
          _context.n = 18;
          break;
        case 6:
          // determine whether the user has logged in
          hasToken = getToken();
          if (!hasToken) {
            _context.n = 17;
            break;
          }
          if (!(to.path === '/login')) {
            _context.n = 7;
            break;
          }
          // if is logged in, redirect to the home page
          next({
            path: '/'
          });
          NProgress.done();
          _context.n = 16;
          break;
        case 7:
          hasRoles = store.getters.roles && store.getters.roles.length > 0;
          if (!hasRoles) {
            _context.n = 10;
            break;
          }
          if (!blockDisabledPetRoute(to, next)) {
            _context.n = 8;
            break;
          }
          return _context.a(2);
        case 8:
          _context.n = 9;
          return getStoreInfoGuideRoute(to);
        case 9:
          _guideRoute = _context.v;
          _guideRoute ? next(_guideRoute) : next();
          _context.n = 16;
          break;
        case 10:
          _context.p = 10;
          if (!hasToken) {
            _context.n = 11;
            break;
          }
          _context.n = 11;
          return store.dispatch('user/getInfo');
        case 11:
          if (!blockDisabledPetRoute(to, next)) {
            _context.n = 12;
            break;
          }
          return _context.a(2);
        case 12:
          _context.n = 13;
          return getStoreInfoGuideRoute(to);
        case 13:
          _guideRoute2 = _context.v;
          _guideRoute2 ? next(_guideRoute2) : next(_objectSpread(_objectSpread({}, to), {}, {
            replace: true
          }));
          _context.n = 16;
          break;
        case 14:
          _context.p = 14;
          _t = _context.v;
          _context.n = 15;
          return store.dispatch('user/resetToken');
        case 15:
          Message.error(_t || 'Has Error');
          next("/login?redirect=".concat(to.path));
          NProgress.done();
        case 16:
          _context.n = 18;
          break;
        case 17:
          /* has no token*/
          if (whiteList.indexOf(to.path) !== -1) {
            // in the free login whitelist, go directly
            next();
          } else {
            // other pages that do not have permission to access are redirected to the login page.
            next("/login?redirect=".concat(to.path));
            NProgress.done();
          }
        case 18:
          return _context.a(2);
      }
    }, _callee, null, [[10, 14]]);
  }));
  return function (_x2, _x3, _x4) {
    return _ref.apply(this, arguments);
  };
}());
router.afterEach(function () {
  // finish progress bar
  NProgress.done();
});